import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet } from 'APIPackage/MainModule/common/apiTools';

import { ITerritorialUnit } from '../interfaces/ITerritorialUnit';

export async function fetchTerritorialUnits(): Promise<ITerritorialUnit[]> {
  return apiGet<ITerritorialUnit[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, false)}/catalogs/territorial-units`,
  );
}

export async function fetchTerritorialUnitsByLevelsCountryFederalDistrictRegions(): Promise<ITerritorialUnit[]> {
  return apiGet<ITerritorialUnit[]>(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
    )}/catalogs/territorial-units/by-levels/country/federal-districts/regions`,
  );
}
